export function dateFormat(time) {
  const nowdata = time == null ? new Date() : new Date(time)
  const year = nowdata.getFullYear()
  const month = nowdata.getMonth() + 1
  const date = nowdata.getDate()
  let nowtime = year + '/'
  if (month < 10) {
    nowtime += '0'
  }
  nowtime += month + '/'
  if (date < 10) {
    nowtime += '0'
  }
  nowtime += date
  return nowtime
}

export function monthFormat(time) {
  const nowdata = time == null ? new Date() : new Date(time)
  const year = nowdata.getFullYear()
  const month = nowdata.getMonth() + 1
  let nowtime = year + '/'
  if (month < 10) {
    nowtime += '0'
  }
  nowtime += month
  return nowtime
}
